import { FormFieldTypes } from "../../../data/formFieldType";
export const xeroPaymentListFormData = {
  name: "XeroPaymentUpdatelistForm",
  initialState: {
    companyName: null,
    paymentStatus: null,
  },
  formFields: [
    {
      id: "companyName",
      lable: "Search by Company Name",
      Field_Name: "Company Name",
      fieldType: FormFieldTypes.INPUT,
      dataField: "companyName",
      fieldSetting: {
        placeholder: "Search by Company Name",
        allowSpace: true,
      },
      style: {
        containerCss:
          "col-lg-6 col-xl-6 col-md-6 col-sm-12 col-12 mb-3 xero-filters",
      },
    },
    {
      id: "paymentStatus",
      lable: "Payment Status",
      Field_Name: "Payment Status",
      fieldType: FormFieldTypes.SELECT,
      dataField: "paymentStatus",
      fieldSetting: {
        placeholder: "Select",
        options: [
          {
            label: "Paid",
            value: 1,
          },
          {
            label: "Pending",
            value: 2,
          },
        ],
      },
      style: {
        containerCss:
          "col-lg-6 col-xl-6 col-md-6 col-sm-12 col-12 mb-3 xero-filters",
      },
    },
  ],
  formSetting: {
    isViewOnly: false,
  },
};
